import { Navigate, Outlet, useMatches } from "react-router-dom";

import { AppBreadcrumbs } from "@/components/app-breadcrumbs";
import { AppSidebar } from "@/components/app-sidebar";
import { PlanLens } from "@/components/plan-lens";
import { Separator } from "@/components/ui/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { useAuth } from "@/global/AuthContext";
import { PlanLensProvider } from "@/global/PlanLensContext";
import { cn } from "@/lib/utils";

import PageTitle from "./PageTitle";

export type AppLayoutHandle = { layout?: "workspace" };

export default function AppLayout() {
  const auth = useAuth();
  const workspace = useMatches().some(
    (match) =>
      (match.handle as AppLayoutHandle | undefined)?.layout === "workspace",
  );
  if (!auth.isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return (
    <PlanLensProvider>
      <PageTitle />
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset
          className={cn(workspace && "h-dvh min-w-0 overflow-hidden")}
        >
          <header className="bg-background sticky top-0 z-10 flex h-12 shrink-0 items-center gap-2 border-b px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <AppBreadcrumbs />
            <PlanLens />
          </header>
          <main
            className={cn(
              "flex-1",
              workspace ? "min-h-0 overflow-hidden" : "overflow-y-auto",
            )}
          >
            {workspace ? (
              <Outlet />
            ) : (
              <div className="container mx-auto px-4 py-6">
                <Outlet />
              </div>
            )}
          </main>
        </SidebarInset>
      </SidebarProvider>
    </PlanLensProvider>
  );
}
